export enum PermissionCode {
   None = 0,
   ViewUsers = 1,
   ManageUsers = 2,
   ViewRoles = 3,
   ManageRoles = 4,
   ConfigureAccessControl = 5,
   ManageLocations = 6,
   ViewStockCategories = 7,
   ManageStockCategories = 8,
   ViewTickets = 9,
   CreateTickets = 10,
   UpdateTicketStatus = 11,
   ApproveTicket = 12,
   ViewReports = 13,
   ViewJobs = 14,
   ManageJobs = 15,
   ViewDepartment = 16,
   ManageDepartment = 17,
   ViewEmployee = 18,
   ManageEmployee = 19,
   ManageTicketType = 20,
   ViewStockItems = 21,
   ManageStockItem = 22,
   ViewStockManufactures = 23,
   ManageStockManufacture = 24,
   ViewStockModels = 25,
   ManageStockModel = 26,
   ViewStockSuppliers = 27,
   ManageStockSupplier = 28,
   ViewBranches = 29,
   ManageBranch = 30,
   ViewCompanies = 31,
   ManageCompany = 32,
}
